"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StateMutation = function StateMutation(mutations) {
  _classCallCheck(this, StateMutation);

  this.mutations = mutations;
}
/**
 * @type {Object<string, *>}
 */
;

exports.default = StateMutation;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/states/mutation/StateMutation.js
// module id = 176
// module chunks = 0